/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { func, string, bool } from 'prop-types';

const Actions = ({ onDownload, icon, disabled, hidden }) => {
  if (hidden) return null;

  return (
    <>
      {disabled ? (
        <span className='disabled-action'>
          <i className={icon} />
        </span>
      ) : (
        <div className="actions-wrapper">
          <i
            className={icon}
            onClick={onDownload}
            role="button"
            tabIndex="0"
            style={{ fontSize: '20px' }}
          />
        </div>
      )}
    </>
  );
};

Actions.propTypes = {
  onDownload: func.isRequired,
  icon: string,
  disabled: bool,
  hidden: bool
};

Actions.defaultProps = {
  icon: 'fa fa-download',
  disabled: false,
  hidden: false
};

export default Actions;
